import { memo } from 'react';
import { tooltip } from './MDTextarea.css';

type Props = {
  top: number;
  left: number;
  label: string;
  href: string;
  onClose: () => void;
  onEdit: () => void;
  onRemove: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

export const MDLinkTooltip = memo(
  ({
    top,
    left,
    label,
    href,
    onClose,
    onEdit,
    onRemove,
    onMouseEnter,
    onMouseLeave,
  }: Props) => (
    <div
      className={tooltip.wrapper}
      style={{ top, left }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={tooltip.title}>
        <span>{label}</span>
        <button
          className={tooltip.close}
          onMouseDown={(e) => e.preventDefault()}
          onClick={onClose}
          data-link-tooltip="true"
          type="button"
        >
          ×
        </button>
      </div>
      <div className={tooltip.link}>{href}</div>
      <div className={tooltip.actions}>
        <button
          className={tooltip.actionVariants.edit}
          onMouseDown={(e) => e.preventDefault()}
          onClick={onEdit}
          data-link-tooltip="true"
          type="button"
        >
          Edit
        </button>
        <button
          className={tooltip.actionVariants.remove}
          onMouseDown={(e) => e.preventDefault()}
          onClick={onRemove}
          data-link-tooltip="true"
          type="button"
        >
          Remove
        </button>
      </div>
    </div>
  ),
);

MDLinkTooltip.displayName = 'MDLinkTooltip';
